module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Etagnieres_(Vaud)-b4865fc898d8eece4ba38337308cead7.svg";